<div class="flex flex-col gap-4">
  <h4 class="text-xl font-semibold leading-tight text-lWhite">Enviar arquivo</h4>

  <l-file-upload-dropzone
    [status]="uploadStatus"
    [fileName]="shownFileName"
    [fileSizeLabel]="fileSizeLabel"
    [inputId]="videoFileInputId"
    accept="video/mp4,video/quicktime,video/x-msvideo"
    idleTitle="Selecione o vídeo para upload"
    [idleHints]="['Formatos aceitos: MP4, MOV, AVI', '(máx 200mb)']"
    replaceButtonLabel="Substituir arquivo"
    [uploadedTitle]="uploadedTitle"
    (fileSelected)="onVideoFileSelected($event)"
  />

  <div class="flex flex-col gap-2">
    <label for="contentVideoTitle" class="text-sm font-medium text-lGray500">
      Título <span class="text-lDanger">*</span>
    </label>
    <div class="relative">
      <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600">edit_note</l-icon>
      <input
        id="contentVideoTitle"
        lInput
        type="text"
        maxlength="120"
        [formControl]="form.controls.videoTitle"
        placeholder="Digite o título do vídeo"
        class="!rounded-xl border-none pl-11"
      />
    </div>
  </div>

  <div class="flex flex-col gap-2">
    <label for="contentVideoThumbnail" class="text-sm font-medium text-lGray500">Thumbnail</label>
    <l-cover-image-upload
      [imageUrl]="form.controls.videoThumbnailUrl.value"
      urlInputId="contentVideoThumbnail"
      fileInputId="contentVideoThumbnailFile"
      urlPlaceholder="Coloque aqui a URL da imagem"
      uploadLabel="Selecionar do computador"
      recommendation="Recomendação de dimensão 16:9 (ex: 1280 × 720)."
      accept="image/png,image/jpeg,image/webp"
      [allowedExtensions]="thumbnailExtensions"
      [maxFileBytes]="maxThumbnailBytes"
      previewAlt="Prévia da thumbnail"
      placeholderAlt="Placeholder da thumbnail"
      (imageUrlChange)="onThumbnailUrlChange($event)"
      (imageFileChange)="onThumbnailFileChange($event)"
    />
  </div>
</div>
